<template>
  <div id="app">
    <sidebar :activeMenu="active_menu" @routerPush="$push" v-if="$store.state.is_show_sidebar" />
    <pc-notice-bar v-if="$store.state.is_show_sidebar" />
    <dcheader v-if="$store.state.is_show_sidebar" />
    <div class="mainContainer">
      <router-view />
    </div>

    <popupOfDialog v-if="showDialog" :type="dialogType" :title="dialogTitle" :message="dialogMsg" :data="dialogData" :showCancelBtn="false" :showConfirmBtn="false" @closePopDialog="closePopDialog"></popupOfDialog>

    <!-- 隐私协议弹窗（首次启动展示，全局安全网） -->
    <privacy-popup ref="privacyPopup" />
  </div>

</template>

<script>
import Vue from 'vue';

let timer, selfCheckController, printCheckController;
let discovered;
let counter = 0;
let vid = document.createElement("audio");
let vidError = document.createElement("audio");

function nowTime() {//获取当前时间 年-月-日 时:分:秒
  let now = new Date();
  let _month = (10 > (now.getMonth() + 1)) ? '0' + (now.getMonth() + 1) : now.getMonth() + 1;
  let _day = (10 > now.getDate()) ? '0' + now.getDate() : now.getDate();
  let _hour = (10 > now.getHours()) ? '0' + now.getHours() : now.getHours();
  let _minute = (10 > now.getMinutes()) ? '0' + now.getMinutes() : now.getMinutes();
  let _second = (10 > now.getSeconds()) ? '0' + now.getSeconds() : now.getSeconds();
  return now.getFullYear() + '-' + _month + '-' + _day + ' ' + _hour + ':' + _minute + ':' + _second;
}

import store from "@/store/index.js";
import PcNoticeBar from '@/components/pcNoticeBar.vue'
import { mapGetters } from 'vuex'
import {
  _isInApp,
  netPrintSend,
  menuPrintFif,
  checkPrintType,
  randomString,
  printTest,
  winPrintSend
} from '@/utils/util';
import { getThisWeightDetail } from './utils/winPrint'
import {
  addFoodPrintLog_global,
  addTestPrintLog_global,
  checkIosLabelPrint,
  checkLabelPrint,
  getPrinterType,
  outPrintdataProcess,
  setFoodPrintLog_global,
  _typeofEnv
} from './utils/util';
import {
  deviceInfo,
  beginPrint,
  connectAuto,
  initScale,
  getScaleData,
  connectUSB,
  connectBluetooth,
  closeConnect,
  imagePrint,
  ipConnect,
  getPrintResInfo,
  labelPrint,
  checkUsbConnect,
  checkTagConnect,
  checkLabelPrintStatus,
  getListener,
  getScaleDataMt,
  getPrinterStatus,
  mtPrintText,
  isScaleSupported,
  tagPrintText,
  iosReceiptPrint,
  scanBleConnect,
  getBleConnectStatus,
  getQtBleConnectStatus,
  getScaleDateHcd,
  getScaleDateSm,
  connectSunMiScaleService,
  sunMiScaleDataInfo,
  getScaleDataRd,
} from './utils/outPrint'
import dcheader from '@/components/dcheader.vue'
import popupOfDialog from '@/components/popupOfDialog.vue';
import privacyPopup from '@/components/privacyPopup.vue';
import { dc_domain } from '../configapi';

export default {
  name: "App",
  store,
  directives: {},
  components: {
    dcheader,
    popupOfDialog,
    PcNoticeBar,
    privacyPopup,
  },
  data() {
    return {
      last: undefined,
      latency: 999,
      showLog: false,
      dcArray: [],
      currentPrint: [],
      canPrint: false, //是否可以打印，
      printing: false, //是否正在打印中
      code: "", //打印信息
      haveConnect: false,
      voiceArray: [],
      isPlaying: false,
      initAudio: false,
      discovered_copy: '',
      printingTime: 0,
      printTimeOut: 10,
      printTimeOutController: 0,
      printDataObserver: 0,// 打印单发现器
      canvasList: [],
      hcArray: [], // 后厨单子
      hcPrinting: false, // 后厨是否正在打印
      labelArray: [], // 标签打印机单子
      labelPrinting: false, // 标签打印是否正在打印
      tagTimer: null,
      active_menu: 22,
      showDialog: false,
      dialogType: '',
      dialogTitle: '',
      dialogMsg: '',
      dialogData: {},
    };
  },
  filters: {},
  computed: {
    ...mapGetters({
      log: "log",
      hcPrintList: "hcPrintList",
      hcPrintRes: 'hcPrintRes',
      stagingHcErr: 'stagingHcErr',
    }),
    connected() {
      return this.$store.state.connected;
    },
    hcPrint_count() {
      return this.$store.state.hcPrintCount;
    },
    qtPrint_count() {
      return this.$store.state.qtPrintCount;
    },
    labelPrintCount() {
      return this.$store.state.labelPrintCount;
    },
    isApp() {
      return localStorage.nowDevice;
    },
  },
  watch: {
    '$store.state.show_pay_tip': {
      handler() {
        if (this.$store.state.show_pay_tip) {
          this.openPayTipModal();
        }
      },
    }
  },
  async created() {
    if (!localStorage.token) {
      return
    }
    await this.$store.dispatch('getStoreInfo');
    this.$store.dispatch("getShopBusinessModel");
    const nowDevice = await _isInApp();
    localStorage.setItem('nowDevice', nowDevice);
    console.log(this.isApp, '--------------');
    if (this.isApp == 'android') {
      if (localStorage.scale_type == '1') {
        getScaleDateHcd();
      } else if (localStorage.scale_type == '4') {
        getScaleData();
      } else if (localStorage.scale_type == '2') {
        await connectSunMiScaleService();
        setTimeout(() => {
          sunMiScaleDataInfo();
        }, 500);
        getScaleDateSm();
      } else if (localStorage.scale_type == '5') {
        getScaleDataRd();
      } else if (localStorage.scale_type == '6') {
        // 判断是否支持内置电子秤
        setTimeout(async () => {
          const scaleSupported = await isScaleSupported();
          this.$store.commit('updateMtScale', scaleSupported);
        }, 1500);
      }
      getPrintResInfo(); // 监听网络打印机打印状态
      document.addEventListener("deviceready", this.handleReady, false);
    } else if (this.isApp == 'windows') {
      window.addEventListener('message', (event) => {
        // console.log('event: ', event);
        // 根据上面制定的结构来解析iframe内部发回来的数据
        const data = event.data
        switch (data.cmd) {
          case 'getToken':
            // 业务逻辑
            window.parent.postMessage(
              {
                cmd: 'setToken',
                app: 'diancan',
                value: localStorage.token
              }, '*')
            break
        }
      })
      getThisWeightDetail();
    } else if (this.isApp == 'ios') {
      document.addEventListener("deviceready", this.handleReadyIos, false);
    } else if (this.isApp == 'mt_android') {
      getPrintResInfo();
      document.addEventListener("deviceready", this.handleReady, false);
      setTimeout(async () => {
        const scaleSupported = await isScaleSupported();
        this.$store.commit('updateMtScale', scaleSupported);
        // console.log('scaleSupported', scaleSupported);
        // console.log('this.$store.state.mtScale', this.$store.state.mtScale);
      }, 1500);
    }
    this.$store.dispatch("setNowTimeStr");
    this.$store.dispatch("getNotifyData");
  },
  async mounted() {
    this.$store.commit('updateIsShowSidebar', localStorage.token ? true : false);
    if (!localStorage.token) {
      return
    }
    var that = this;
    if (this.isApp == 'windows') {
      await this.$device.getLocalIP();
      if (localStorage.token) {
        checkPrintType();
      }
    }
    // 写入UUID
    that.setUUID();
    // 初始化bus
    that.initListeners();
    this.launchPrintTask();

    String.prototype.realLength = function (str) {
      var realLength = 0,
        len = str.length,
        charCode = -1;
      for (var i = 0; i < len; i++) {
        charCode = str.charCodeAt(i);
        if (charCode >= 0 && charCode <= 128) {
          realLength += 1;
        } else {
          realLength += 2;
        }
        return realLength;
      }
    };

  },
  methods: {
    closePopDialog() {
      this.showDialog = false;
    },
    openPayTipModal() {
      this.$bus.$emit('openAuthBuyModal', { errMsg: this.$store.state.pay_tip_msg });
    },
    closeNotify() {
      this.$store.commit('updateIsShowNotify', false);
    },
    async checkPrintAll() {
      clearInterval(this.tagTimer);
      this.tagTimer = null;
      if (localStorage.printType == 1) {
        const tagR = await checkUsbConnect(1);
        if (tagR.code == 1) {
          checkLabelPrint();
        }
      } else {
        // console.log('0000000000');
        checkLabelPrint();
      }
      // 设置了前台USB打印机
      this.tagTimer = setInterval(async () => {
        // console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~');
        if (localStorage.printType == 1) {
          const tagR = await checkUsbConnect(1);
          if (tagR.code == 1) {
            clearInterval(this.tagTimer);
            this.tagTimer = null;
            checkLabelPrint();
          }
        } else {
          clearInterval(this.tagTimer);
          this.tagTimer = null;
          checkLabelPrint();
        }
      }, 8000);
    },
    async handleReady() {
      deviceInfo();
      if (localStorage.token) {
        getListener();
        await checkPrintType();
        this.checkPrintAll();
      }
    },
    async handleReadyIos() {
      this.$store.commit('updateDeviceMac', device.uuid);
      // scanBleConnect();
      if (localStorage.token) {
        await checkPrintType();
        checkIosLabelPrint();
      }
    },
    // 启动打印任务
    launchPrintTask() {
      const that = this;
      // 启动打印任务
      clearInterval(timer);
      if (localStorage.token) {
        timer && clearInterval(timer);
        timer = setInterval(() => {
          try {
            that.printMenu();
            that.printHcMenu();
            that.playAudio();
            that.printLabel();
            that.updateDisplayDcArray();
          } catch (e) {
            // console.log('printMenu error', e)
          }
        }, 2000);
      }
    },
    // 标签打印机
    async printLabel() {
      // console.log('labelArray', this.labelArray, 'labelPrinting', this.labelPrinting);
      if (this.labelArray.length > 0 && !this.labelPrinting) {
        let curLabelPrint = this.labelArray[0];
        // console.log('curLabelPrint', curLabelPrint);
        this.labelPrinting = true;
        const tag_printer = this.$store.state.tagPrinter || [];
        const printer_type = getPrinterType(tag_printer[0].printer_type.toString(), 1, 3);
        console.log('printer_type', printer_type);
        if (printer_type == 7 || printer_type == 12) { // 安卓USB 安卓蓝牙
          if (typeof OutSunmiPrint != 'undefined') {
            const tagRes = await checkTagConnect();
            if (tagRes.code == 1) {
              // await checkLabelPrintStatus();
              this.$store.commit('updateLabelPrintCount', 0);
              let printdataOfLabel = outPrintdataProcess(curLabelPrint);
              // console.log('处理后数据', JSON.stringify(printdataOfLabel));
              labelPrint(printdataOfLabel, curLabelPrint.labelSize || 50);
              this.labelArray.splice(0, 1);
              this.labelPrinting = false;
            } else {
              this.$store.commit('updateLabelPrintCount', this.labelPrintCount + 1);
              this.labelArray.splice(0, 1);
              if (this.labelPrintCount > 0 && this.labelPrintCount < 3) {
                this.labelArray.push(curLabelPrint);
              } else {
                this.$store.commit('updateLabelPrintCount', 0);
              }
              this.labelPrinting = false;
            }
          } else {
            this.$store.commit('updateLabelPrintCount', 0);
            this.labelArray.splice(0, 1);
            this.labelPrinting = false;
          }
        } else if (printer_type == 8) { //win驱动
          if (tag_printer.length < 1 || !tag_printer[0].printer_name || tag_printer[0].printer_name == '') {
            this.$toast('标签打印机设置有误，请检查配置');
            this.$store.commit('updateLabelPrintCount', 0);
            this.labelArray.splice(0, 1);
            this.labelPrinting = false;
            return;
          }
          winPrintSend(curLabelPrint).then(res => {
            this.$store.commit('updateLabelPrintCount', 0);
            this.labelArray.splice(0, 1);
            this.labelPrinting = false;
          }).catch((err) => {
            this.$store.commit('updateLabelPrintCount', 0);
            this.labelArray.splice(0, 1);
            this.labelPrinting = false;
            this.$toast('标签制作单打印失败');
          });
        } else if (printer_type == 9) { // IOS蓝牙
          const tagRes = await getBleConnectStatus();
          // console.log('tagRes, iOS, 打印', tagRes);
          if (tagRes.code == 1) {
            this.$store.commit('updateLabelPrintCount', 0);
            let printdataOfLabel = outPrintdataProcess(curLabelPrint);
            // console.log('处理后数据', JSON.stringify(printdataOfLabel));
            let tagContent = [{ "list": printdataOfLabel }]
            // console.log('最终处理数据：', tagContent);
            tagPrintText(tagContent, curLabelPrint.labelSize || 50);
            this.labelArray.splice(0, 1);
            this.labelPrinting = false;
          } else {
            this.$store.commit('updateLabelPrintCount', 0);
            this.labelArray.splice(0, 1);
            this.labelPrinting = false;
          }
        } else if (printer_type == 11) { // 佳博云
          let printdataOfOut = outPrintdataProcess(curLabelPrint);
          // console.log('佳博云标签机 处理后数据', JSON.stringify(printdataOfOut));
          let daD = new FormData();
          daD.append('print_content', JSON.stringify(printdataOfOut));
          daD.append('shop_id', localStorage.shop_id);
          // daD.append('order_id', (that.currentPrint[0].oid || that.currentPrint[0].order_id) || 0);
          daD.append('cloud_sn', tag_printer[0].cloud_sn);
          let size = 1; // 1：50*40，2：40*30
          if (curLabelPrint.labelSize == 40) {
            size = 2;
          }
          daD.append('size', size);
          this.$api.jiabo_tagPrint(daD).then(res => {
            // console.log('标签 佳博云打印机 res', res);
            if (res.code == 1) {
              this.$store.commit('updateLabelPrintCount', 0);
              this.labelArray.splice(0, 1);
              this.labelPrinting = false;
            } else {
              this.$store.commit('updateLabelPrintCount', 0);
              this.labelArray.splice(0, 1);
              this.labelPrinting = false;
              this.$toast('标签制作单打印失败');
            }
          }).catch((err) => {
            // console.log('标签 佳博云打印机打印失败', err);
            this.$store.commit('updateLabelPrintCount', 0);
            this.labelArray.splice(0, 1);
            this.labelPrinting = false;
            this.$toast('标签制作单打印失败');
          });
        }
        // else if (printer_type == 12) { // 安卓蓝牙
        //   if (typeof OutSunmiPrint != 'undefined') {
        //     const tagRes = await checkTagConnect();
        //     console.log(tagRes, 'tagRes');
        //     this.$store.commit('updateLabelPrintCount', 0);
        //     let printdataOfLabel = outPrintdataProcess(curLabelPrint);
        //     console.log('处理后数据', JSON.stringify(printdataOfLabel));
        //     labelPrint(printdataOfLabel, curLabelPrint.labelSize || 50);
        //     this.labelArray.splice(0, 1);
        //     this.labelPrinting = false;
        //   } else {
        //     this.$store.commit('updateLabelPrintCount', 0);
        //     this.labelArray.splice(0, 1);
        //     this.labelPrinting = false;
        //   }
        // }
      }
    },
    async printHcMenu() {
      //console.log('后厨==============', this.hcArray, this.hcPrinting);
      // console.log('hcPrint_count---------------------', this.hcPrint_count);
      if (this.hcArray.length > 0 && !this.hcPrinting && this.hcPrint_count < 3) {
        this.hcPrinting = true;
        let curHcPrint = this.hcArray[0];
        // console.log('===========================', curHcPrint);
        if ((this.isApp == 'android' || this.isApp == 'mt_android') && curHcPrint.hcPrinterType == '4') {
          let printdataOfOut = [];
          if (curHcPrint.isReprint == 1) {
            ipConnect('ip', curHcPrint.print_ip, JSON.parse(curHcPrint.content), curHcPrint.print_size);
          } else {
            printdataOfOut = outPrintdataProcess(curHcPrint);
            // console.log('后厨处理后数据', JSON.stringify(printdataOfOut));
            ipConnect('ip', curHcPrint.ip, printdataOfOut, curHcPrint.size);
          }
          setTimeout(() => {
            // console.log('this.hcPrintRes', JSON.stringify(this.hcPrintRes));
            // 1： 正在打印 2： 打印结束 3： 打印失败，请重新连接
            if (this.hcPrintRes.code == 2) {
              // 添加测试打印日志
              if (curHcPrint.printtest == 'test' && curHcPrint.print_id) {
                addTestPrintLog_global(curHcPrint, '1', printdataOfOut);
              }
              // 添加菜品打印日志，不是补打（做菜单）
              if (curHcPrint.type == 3 && curHcPrint.printtest == '' && curHcPrint.print_id && curHcPrint.isReprint != 1) {
                addFoodPrintLog_global(curHcPrint, '1', printdataOfOut);
              }
              // 添加菜品打印日志，是补打
              if (curHcPrint.print_id && curHcPrint.isReprint == 1) {
                setFoodPrintLog_global(curHcPrint.id);
              }
              if (this.stagingHcErr[`${curHcPrint.ip}`]) {
                this.$delete(this.stagingHcErr, curHcPrint.ip);
                this.$store.commit('updateStagingHcErr', this.stagingHcErr);
              }
              if (this.stagingHcErr[`${curHcPrint.print_ip}`]) {
                this.$delete(this.stagingHcErr, curHcPrint.print_ip);
                this.$store.commit('updateStagingHcErr', this.stagingHcErr);
              }
              this.$store.commit('updateHcPrintCount', 0);
              this.hcArray.splice(0, 1);
              this.hcPrinting = false;
            } else if (this.hcPrintRes.code == 3 || this.hcPrintRes.code == 0) {
              this.$store.commit('updateHcPrintCount', 0);
              if (curHcPrint.ip) {
                let obj = {};
                obj[`${curHcPrint.ip}`] = (this.stagingHcErr[`${curHcPrint.ip}`] || 0) + 1;
                this.$store.commit('updateStagingHcErr', Object.assign(this.stagingHcErr, obj))
                this.$toast(`${curHcPrint.ip}${this.hcPrintRes.msg}`);
                this.hcArray.splice(0, 1);
                if (this.stagingHcErr[`${curHcPrint.ip}`] < 5) {
                  this.hcArray.push(curHcPrint);
                } else {
                  // 添加测试打印日志
                  if (curHcPrint.printtest == 'test' && curHcPrint.print_id) {
                    addTestPrintLog_global(curHcPrint, '0', printdataOfOut);
                  }
                  // 添加菜品打印日志，补打的时候失败不更新（做菜单）
                  if (curHcPrint.type == 3 && curHcPrint.printtest == '' && curHcPrint.print_id && curHcPrint.isReprint != 1) {
                    addFoodPrintLog_global(curHcPrint, '0', printdataOfOut);
                  }
                  // 后厨打印机连接异常
                  this.voiceArray.push({
                    type: 1,
                    path: '/voice/connection_exception_hc.MP3'
                  });
                  this.$delete(this.stagingHcErr, curHcPrint.ip);
                  this.$store.commit('updateStagingHcErr', this.stagingHcErr);
                }
              }
              if (curHcPrint.print_ip) {
                let obj = {};
                obj[`${curHcPrint.print_ip}`] = (this.stagingHcErr[`${curHcPrint.print_ip}`] || 0) + 1;
                this.$store.commit('updateStagingHcErr', Object.assign(this.stagingHcErr, obj))
                this.$toast(`${curHcPrint.print_ip}${this.hcPrintRes.msg}`);
                this.hcArray.splice(0, 1);
                if (this.stagingHcErr[`${curHcPrint.print_ip}`] < 5) {
                  this.hcArray.push(curHcPrint);
                } else {
                  // 添加测试打印日志
                  if (curHcPrint.printtest == 'test' && curHcPrint.print_id) {
                    addTestPrintLog_global(curHcPrint, '0', printdataOfOut);
                  }
                  // 添加菜品打印日志，补打的时候失败不更新（做菜单）
                  if (curHcPrint.type == 3 && curHcPrint.printtest == '' && curHcPrint.print_id && curHcPrint.isReprint != 1) {
                    addFoodPrintLog_global(curHcPrint, '0', printdataOfOut);
                  }
                  // 后厨打印机连接异常
                  this.voiceArray.push({
                    type: 1,
                    path: '/voice/connection_exception_hc.MP3'
                  });
                  this.$delete(this.stagingHcErr, curHcPrint.print_id);
                  this.$store.commit('updateStagingHcErr', this.stagingHcErr);
                }
              }
              this.hcPrinting = false;
            }
          }, 500);
        }
        else if (this.isApp == 'windows' && curHcPrint.hcPrinterType == '4') {
          // Windows后厨打印
          netPrintSend(curHcPrint).then(res => {
            // console.log('后厨打印 res', res);
            if (res.code == 1) {
              this.$store.commit('updateHcPrintCount', 0);
              this.hcArray.splice(0, 1);
              this.hcPrinting = false;
            } else {
              // console.log('后厨网络打印机打印失败 res---', res);
              this.$store.commit('updateHcPrintCount', this.hcPrint_count + 1);
              this.hcArray.splice(0, 1);
              // this.hcArray.push(curHcPrint);//放置尾部
              this.hcPrinting = false;
              this.$toast(err.msg || '打印失败')
            }
          }).catch((err) => {
            // console.log('后厨网络打印机打印失败 catch', err);
            this.$store.commit('updateHcPrintCount', this.hcPrint_count + 1);
            this.hcArray.splice(0, 1);
            // this.hcArray.push(curHcPrint);//放置尾部
            this.hcPrinting = false;
            if (err) {
              this.$toast(err.msg || '打印失败')
            }
          });
        }
        else if (this.isApp == 'ios' || curHcPrint.hcPrinterType == '6') {
          // IOS
          // let printdataOfOut = outPrintdataProcess(curHcPrint);
          // console.log('后厨 处理后数据', JSON.stringify(printdataOfOut));
          let print_content = [];
          print_content[0] = curHcPrint.hc_p_data;
          let daD = new FormData();
          daD.append('print_content', JSON.stringify(print_content));
          daD.append('shop_id', localStorage.shop_id);
          daD.append('order_id', (curHcPrint.original_data.oid || curHcPrint.original_data.order_id) || 0);
          daD.append('cloud_sn', curHcPrint.original_data.cloud_sn);
          // 4 ： 通用新订单提醒 9：补打订单 6 通用退单提配醒 5 ： 通用取消订单提醒 10	简短 - 通用新订单提醒	您有新的订单了 11	简短 - 取消订单提醒	有用户退单
          daD.append('voice_type', curHcPrint.original_data.type == 18 ? 11 : 10);
          this.$api.daqPrint_dqPrint(daD).then(res => {
            // console.log('后厨 大趋云打印机 res', res);
            if (res.code == 1) {
              this.$store.commit('updateHcPrintCount', 0);
              this.hcArray.splice(0, 1);
              this.hcPrinting = false;
            } else {
              this.$store.commit('updateHcPrintCount', 0);
              let obj = {};
              obj[`${curHcPrint.original_data.cloud_sn}`] = (this.stagingHcErr[`${curHcPrint.original_data.cloud_sn}`] || 0) + 1;
              this.$store.commit('updateStagingHcErr', Object.assign(this.stagingHcErr, obj))
              this.hcArray.splice(0, 1);
              this.$toast(`${curHcPrint.original_data.cloud_sn}${res.msg}`);
              if (this.stagingHcErr[`${curHcPrint.original_data.cloud_sn}`] < 3) {
                this.hcArray.push(curHcPrint);
              } else {
                this.$delete(this.stagingHcErr, curHcPrint.original_data.cloud_sn);
              }
              this.hcPrinting = false;
            }
          }).catch((err) => {
            this.$store.commit('updateHcPrintCount', 0);
            this.hcArray.splice(0, 1);
            this.hcPrinting = false;
          });
        }
        else if (curHcPrint.hcPrinterType == '7') {
          // 佳博云打印机
          // let printdataOfOut = outPrintdataProcess(curHcPrint);
          // console.log('后厨 处理后数据', JSON.stringify(printdataOfOut));
          let print_content = [];
          print_content[0] = curHcPrint.hc_p_data;
          let daD = new FormData();
          daD.append('print_content', JSON.stringify(print_content));
          daD.append('shop_id', localStorage.shop_id);
          daD.append('order_id', (curHcPrint.original_data.oid || curHcPrint.original_data.order_id) || 0);
          daD.append('cloud_sn', curHcPrint.original_data.cloud_sn);
          // 4 ： 通用新订单提醒 9：补打订单 6 通用退单提配醒 5 ： 通用取消订单提醒 10	简短 - 通用新订单提醒	您有新的订单了 11	简短 - 取消订单提醒	有用户退单
          daD.append('voice_type', curHcPrint.original_data.type == 18 ? 11 : 10);
          daD.append('size', curHcPrint.original_data.size || 58);
          this.$api.jiabo_print(daD).then(res => {
            // console.log('后厨 大趋云打印机 res', res);
            if (res.code == 1) {
              this.$store.commit('updateHcPrintCount', 0);
              this.hcArray.splice(0, 1);
              this.hcPrinting = false;
            } else {
              this.$store.commit('updateHcPrintCount', 0);
              let obj = {};
              obj[`${curHcPrint.original_data.cloud_sn}`] = (this.stagingHcErr[`${curHcPrint.original_data.cloud_sn}`] || 0) + 1;
              this.$store.commit('updateStagingHcErr', Object.assign(this.stagingHcErr, obj))
              this.hcArray.splice(0, 1);
              this.$toast(`${curHcPrint.original_data.cloud_sn}${res.msg}`);
              if (this.stagingHcErr[`${curHcPrint.original_data.cloud_sn}`] < 3) {
                this.hcArray.push(curHcPrint);
              } else {
                this.$delete(this.stagingHcErr, curHcPrint.original_data.cloud_sn);
              }
              this.hcPrinting = false;
            }
          }).catch((err) => {
            this.$store.commit('updateHcPrintCount', 0);
            this.hcArray.splice(0, 1);
            this.hcPrinting = false;
          });
        }
      }
    },
    // 清空打印列表
    clearPrintList() {
      this.dcArray = [];
      // this.currentPrint = [];
      this.canPrint = false;
      this.printing = false;
      this.$store.commit('setPrinting', false);
      this.$toast('清除了打印列表');

    },
    updateDisplayDcArray() {
      this.$store.commit("updateDisplayDcArray", this.dcArray || []);
    },
    setFoodForStyle(element) {
      let arr = [];
      for (let j = 0; j < element.foodsList.length; j++) {
        const ele = element.foodsList[j];
        let newFoods = [];
        newFoods.push(ele);
        const everyMenu = Object.assign({}, element, {
          foodsList: newFoods,
        });
        arr.push(everyMenu);
      }
      return arr;
    },
    //是否多设备打印
    multiPrint(data) {
      console.log("%c Line:705 🥓 data", "color:#f5ce50", data);
      if (data.printTypes && data.printTypes.length > 0) { //如果存在printTypes，则需要多设备打印，拆分为多任务 或者是测试打印
        data.printTypes.forEach((x, i) => {
          let obj = JSON.parse(JSON.stringify(data));//深拷贝，避免修改原数据
          obj.ip = data.ips[i];
          obj.size = data.sizes[i];
          obj.print_type = x;
          this.dcArray.push(obj);
        })
      } else {
        this.dcArray.push(data)
      }
    },
    // 初始化 bus
    initListeners() {
      // 下单打印
      this.$bus.$on('addFromHall1', data => {
        if (localStorage.printType) {
          discovered = true;
        } else {
          discovered = false;
          return;
        }
        this.discovered_copy = discovered;
        this.multiPrint(data);
        this.canPrint = true;
        this.$store.commit('updateQtPrintCount', 0);
      })
      // 结账单打印
      this.$bus.$on('addFromHall2', data => {
        if (localStorage.printType) {
          discovered = true;
        } else {
          discovered = false;
          return;
        }
        this.discovered_copy = discovered;
        // const index = this.dcArray.findIndex(e => e.orderNum == data.orderNum);
        // if (index < 0) {
        this.multiPrint(data);
        this.canPrint = true;
        this.$store.commit('updateQtPrintCount', 0);
        // }
      })
      // 桌码打印
      this.$bus.$on('addFromHall3', data => {
        if (localStorage.printType) {
          discovered = true;
        } else {
          discovered = false;
          return;
        }
        this.discovered_copy = discovered;
        this.dcArray.push(data)
        this.canPrint = true;
        this.$store.commit('updateQtPrintCount', 0);
      })
      // 厨师码打印（旧后厨，暂时没用到）
      this.$bus.$on('addCookCode', data => {
        if (localStorage.printType) {
          discovered = true;
        } else {
          discovered = false;
          return;
        }
        this.discovered_copy = discovered;
        this.dcArray.push(data)
        this.canPrint = true;
      })
      // 后厨未打印菜品打印（旧后厨，暂时没用到）
      this.$bus.$on('addPrintList', data => {
        if (localStorage.printType) {
          discovered = true;
        } else {
          discovered = false;
          return;
        }
        this.discovered_copy = discovered;
        // console.log('addPrintList', data, this.hcPrintList);
        data.forEach(e => {
          let ob = e.data;
          if (this.hcPrintList[e.data.order_num]) {
            // 已存在的打印任务
          } else {
            // 处理用户忌口及喜好
            let newStr = "";
            try {
              if (ob.avoid_id != null || ob.avoid_id != "null") {
                ob.avoid_id.forEach(item => {
                  newStr += `${item.avoid || ''},`;
                });
                newStr += `${ob.remark || ''}`;
              }
            } catch (e) {

            }
            var print_uuid = this.uuid2();
            let newObj = Object.assign(
              ob,
              { type: 3 },
              { flavours: newStr },
              { print_uuid: print_uuid },
              { print_time: nowTime() }
            );
            var flavorText = newObj.flavours ? newObj.flavours : "";
            newObj.voiceMessage = newObj.food_name + ',' + newObj.food_num + "份" + flavorText
            this.dcArray.push(newObj);
            this.$store.commit('addHcPrintList', e.data.order_num)
            this.canPrint = true;
          }
        })
      })
      // 处理重复打印（旧后厨，暂时没用到）
      this.$bus.$on('againPrint', data => {
        if (localStorage.printType) {
          discovered = true;
        } else {
          discovered = false;
          return;
        }
        this.discovered_copy = discovered;
        // console.log('againPrint', data, this.hcPrintList);
        data.forEach(e => {
          let ob = e.data;
          // if (this.hcPrintList[e.data.order_num]) {
          // 已存在的打印任务
          // } else {
          // 处理用户忌口及喜好
          let newStr = "";
          try {
            if (ob.avoid_id != null || ob.avoid_id != "null") {
              ob.avoid_id.forEach(item => {
                // 拼接忌口
                newStr += `${item.avoid || item},`;
              });
              // 最后加上备注
              newStr += `${ob.remark}`;
            }
          } catch (e) {

          }
          var print_uuid = this.uuid2();
          let newObj = Object.assign(
            ob,
            { type: 3 },
            { flavours: newStr },
            { print_uuid: print_uuid },
            { again: true },
            { print_time: nowTime() }
          );
          var flavorText = newObj.flavours ? newObj.flavours : "";
          newObj.voiceMessage = newObj.food_name + newObj.food_num + "份" + flavorText
          this.dcArray.push(newObj);
          this.$store.commit('addHcPrintList', e.data.order_num)
          this.canPrint = true;
          // }
        })
      })
      // 清除打印队列
      this.$bus.$on('clearDcArray', data => {
        this.dcArray = [];
        // this.currentPrint = [];
        this.canPrint = false;
        this.printing = false;
        this.$store.commit('setPrinting', false);
        // console.log('清除打印队列');
        this.$store.commit('updateQtPrintCount', 0);
      })
      // 后厨做菜单打印
      this.$bus.$on('menuPrint', data => {
        console.log('做菜单打印信息：', data);
        this.$store.commit('updateHcPrintCount', 0);
        const menudata = menuPrintFif(data);
        console.log('menudata', menudata);
        for (let i = 0; i < menudata.length; i++) {
          const element = menudata[i];
          element.printChannel = 'network';
          if (element.ip) {
            this.$delete(this.stagingHcErr, element.ip);
            this.$store.commit('updateStagingHcErr', this.stagingHcErr);
          }
          if (this.isApp == 'ios' || element.hcPrinterType == '6' || element.hcPrinterType == '7') {
            let printdataOfOut = outPrintdataProcess(element);
            // console.log('printdataOfOut-----------', printdataOfOut);
            let arr_6 = [];
            printdataOfOut.forEach(p_ele => {
              arr_6.push({
                'hcPrinterType': element.hcPrinterType,
                'original_data': element,
                'hc_p_data': p_ele,
              })
            });
            this.hcArray.push(...arr_6);
          } else {
            this.hcArray.unshift(element);
          }
        }
        this.hcPrinting = false;
      })
      // 安卓-后厨做菜单补打
      this.$bus.$on('menuReprint', data => {
        if (this.isApp == 'android' || this.isApp == 'mt_android') {
          data['hcPrinterType'] = '4';
          // data['printerType'] = data.print_type;
          this.$store.commit('updateHcPrintCount', 0);
          if (data.print_ip) {
            this.$delete(this.stagingHcErr, data.print_ip);
            this.$store.commit('updateStagingHcErr', this.stagingHcErr);
          }
          this.hcArray.push(data);
          this.hcPrinting = false;
        }
      })
      this.$bus.$on('clearAppTimer', data => {
        clearInterval(timer);
        clearInterval(this.tagTimer);
      })
      // 后厨退菜单打印
      this.$bus.$on('returnMenuPrint', data => {
        // console.log('后厨退菜单打印信息：', data);
        if (data.hcPrinterType == '4' && data.ip != '') {
          const menudata = Object.assign(
            data,
            {
              printChannel: 'network',
            },
          );
          this.hcArray.unshift(menudata);
          this.$store.commit('updateHcPrintCount', 0);
        } else if (data.cloud_sn != '' && data.cloud_sn > 0) {
          let printdataOfOut = outPrintdataProcess(data);
          let arr_6 = [];
          printdataOfOut.forEach(p_ele => {
            arr_6.push({
              'hcPrinterType': data.hcPrinterType || '',
              'original_data': data,
              'hc_p_data': p_ele,
            })
          });
          this.hcArray.push(...arr_6);
          // this.hcArray.unshift(data);
          this.$store.commit('updateHcPrintCount', 0);
        }
        this.hcPrinting = false;
      })
      // 前台做菜单打印
      this.$bus.$on('qtMenuPrint', data => {
        if (localStorage.printType) {
          discovered = true;
        } else {
          discovered = false;
          return;
        }
        this.discovered_copy = discovered;
        // console.log('前台做菜单打印', data);
        this.multiPrint(data);
        this.canPrint = true;
        this.$store.commit('updateQtPrintCount', 0);
      })
      this.$bus.on('launchPrintTask', data => {
        this.launchPrintTask();
      })
      // 传菜单打印，暂时没用到
      this.$bus.$on('passThoughtPrint', data => {
        // console.log('传菜单打印信息：', data);
        // var print_uuid = this.uuid2();
        // var logObj = {
        //   time: new Date(),
        //   data: data,
        //   case: 24,
        //   explain: '传菜单打印',
        //   print_uuid: print_uuid
        // }
        // this.$store.commit('addLog', logObj)
        // this.$store.commit('updateHcPrintCount', 0);
        // const menudata = menuPrintFif(data);
        // for (let i = 0; i < menudata.length; i++) {
        //   const element = menudata[i];
        //   element.printChannel = 'network';
        //   this.hcArray.push(element);
        // }
      })
      // 日报打印
      this.$bus.$on('dailyPrint', data => {
        if (localStorage.printType) {
          discovered = true;
        } else {
          discovered = false;
          return;
        }
        this.discovered_copy = discovered;
        this.dcArray.push(data)
        this.canPrint = true;
        this.$store.commit('updateQtPrintCount', 0);
      })
      // 前台退菜单打印
      this.$bus.$on('QtReturnMenuPrint', data => {
        if (localStorage.printType) {
          discovered = true;
        } else {
          discovered = false;
          return;
        }
        this.discovered_copy = discovered;
        // console.log('前台退菜单打印信息：', data);
        this.multiPrint(data);
        this.canPrint = true;
        this.$store.commit('updateQtPrintCount', 0);
      })
      // 语音播报队列
      this.$bus.on('beginVoice', data => {
        this.voiceArray.push(data);
      })
      // 客单打印
      this.$bus.$on('guestPrinting', data => {
        if (localStorage.printType) {
          discovered = true;
        } else {
          discovered = false;
          return;
        }
        this.discovered_copy = discovered;
        this.dcArray.push(data)
        this.canPrint = true;
        this.$store.commit('updateQtPrintCount', 0);
      })
      // 前台换台通知单打印
      this.$bus.$on('QtChangeDeskPrint', data => {
        if (localStorage.printType) {
          discovered = true;
        } else {
          discovered = false;
          return;
        }
        this.discovered_copy = discovered;
        // console.log('前台退菜单打印信息：', data);
        this.dcArray.push(data)
        this.canPrint = true;
        this.$store.commit('updateQtPrintCount', 0);
      })
      // 前台标签制作单打印
      this.$bus.$on('qtLabelPrint', data => {
        // console.log('qtLabelPrint', data);
        // if (this.isApp == 'ios') {
        //   return;
        // }
        this.$store.commit('updateLabelPrintCount', 0);
        this.labelPrinting = false;
        if (data.labelFoods.length < 1) {
          return;
        }
        // console.log('qtLabelPrint', data);
        this.labelArray.push(data)
        // const menudata = labelPrintFif(data);
        // for (let i = 0; i < menudata.length; i++) {
        //   const element = menudata[i];
        //   this.hcArray.unshift(element);
        // }
      })
      // 充值单打印
      this.$bus.$on('rechargePrint', data => {
        if (localStorage.printType) {
          discovered = true;
        } else {
          discovered = false;
          return;
        }
        this.discovered_copy = discovered;
        this.dcArray.push(data)
        this.canPrint = true;
        this.$store.commit('updateQtPrintCount', 0);
      })
      // 传入菜单active
      this.$bus.$on('updateMenuActive', data => {
        this.active_menu = data;
      })
      // 寄存单打印
      this.$bus.$on('checkPrint', data => {
        if (localStorage.printType) {
          discovered = true;
        } else {
          discovered = false;
          return;
        }
        this.discovered_copy = discovered;
        this.dcArray.push(data)
        this.canPrint = true;
        this.$store.commit('updateQtPrintCount', 0);
      })
      // 取回单打印
      this.$bus.$on('recaptionPrint', data => {
        if (localStorage.printType) {
          discovered = true;
        } else {
          discovered = false;
          return;
        }
        this.discovered_copy = discovered;
        this.dcArray.push(data)
        this.canPrint = true;
        this.$store.commit('updateQtPrintCount', 0);
      })
    },
    onDeviceReady() {
      const that = this;
      // console.log(device);
      localStorage.setItem("uuid", device.uuid);
    },
    setUUID() {
      if (this.isApp != 'windows') {
        localStorage.removeItem('uuid');
        document.addEventListener("deviceready", this.onDeviceReady, false);
      } else {
        if (!localStorage.uuid) {
          localStorage.setItem("uuid", 'pc' + randomString(10, 'abcdefhijkmnprstwxyz123456789'));
        }
      }
    },
    //播放语音
    playAudio() {
      var that = this;
      //播放语音的数组 voiceArray
      // console.log("播放语音队列", that.voiceArray, this.isPlaying);
      if (this.$store.state.otherVoice.length > 0) {
        that.voiceArray.push(...this.$store.state.otherVoice);
        that.$store.commit('updateOtherVoice', []);
      }
      if (that.voiceArray.length > 0 && !that.isPlaying) {
        that.isPlaying = true;
        if (that.voiceArray[0].type != 1) {
          let query = new FormData();
          query.append('text', that.voiceArray[0]);
          this.$api.text2video(query).then(res => {
            if (res.code == 1 && res.data && res.data != '') {
              vid.src = res.data;
              vid.autoplay = false;
              vid.play();
              if (!that.initAudio) {
                that.initAudio = true;
                vid.addEventListener("ended", function () {
                  that.voiceArray.shift();
                  that.isPlaying = false;
                });
              }
            } else {
              that.initAudio = false;
              that.voiceArray.shift();
              that.isPlaying = false;
            }
          }).catch(() => {
            that.initAudio = false;
            that.voiceArray.shift();
            that.isPlaying = false;
          })
        } else {
          vid.src = dc_domain + that.voiceArray[0].path;
          vid.autoplay = false;
          vid.play();
          if (!that.initAudio) {
            that.initAudio = true;
            vid.addEventListener("ended", function () {
              that.voiceArray.shift();
              that.isPlaying = false;
            });
          }
        }
      }
    },
    // 下菜单
    async printMenu() {
      let that = this;
      // console.log([{ printing: that.printing }, { canPrint: that.canPrint }, { dcArray: that.dcArray }]);
      console.log('that.dcArray: ', that.dcArray);
      if (that.dcArray.length > 0) {
        that.$store.commit("updateDisplayDcArray", that.dcArray);
        // that.$toast(`正在尝试打印，当前打印任务共${that.dcArray.length}个。`)
      }
      if (!that.printing && that.canPrint && that.dcArray.length && this.qtPrint_count < 3) {
        // 处理多设备打印
        if (that.dcArray[0].printTypes && that.dcArray[0].printTypes.length > 0) {
          let printType = getPrinterType(that.dcArray[0].print_type.toString(), 1); //由于前端与后台的打印机类型值不同，进行转换
          localStorage.setItem('printType', printType);
          localStorage.setItem('qiantaiPrintIp', that.dcArray[0].ip);
          localStorage.setItem('qiantaiPrintSize', that.dcArray[0].size);
        }
        console.log("%c Line:1189 🥤 localStorage.printType", "color:#fca650", localStorage.printType);
        if (localStorage.printType) {
          discovered = true;
        } else {
          discovered = false;
          // this.$toast('未设置打印机')
          return;
        }
        that.discovered_copy = discovered;
        // 每次弹出第一条用于打印
        that.currentPrint = [];
        let len = that.dcArray.length;
        let cutArray;
        that.currentPrint.push(that.dcArray[0])
        cutArray = that.currentPrint;
        if (!that.currentPrint || !that.currentPrint.length) {
          // 初始化打印机
          that.canPrint = false;
          that.printing = false;
          that.$store.commit('setPrinting', false);
          return;
        }
        that.printing = true;
        that.$store.commit('setPrinting', true);
        //console.log('进入了', localStorage.printType)
        // //alert('找到usb');
        // 🆕 iOS 蓝牙前台打印机处理
        if (this.isApp == 'ios' && localStorage.printType == '12') {
            console.log('🍎 进入 iOS 蓝牙前台打印逻辑');
            
            // 检查蓝牙连接状态
            const bleStatus = await getQtBleConnectStatus();
            console.log('🔗 iOS 蓝牙状态:', bleStatus);
            
            if (bleStatus.code == 1) {
                this.$store.commit('updateQtPrintCount', 0);
                
                try {
                    // 处理打印数据 (复用标签打印的数据处理方法)
                    let printdataOfReceipt = outPrintdataProcess(
                        that.currentPrint[0], 
                        '', 
                        localStorage.qiantaiPrintSize
                    );
                    let dataContent = [{ "list": printdataOfReceipt }]
                    // 🔑 关键：调用封装的 iOS 小票打印方法
                    await iosReceiptPrint(dataContent, localStorage.qiantaiPrintSize);
                    
                    that.dcArray.splice(0, 1);
                    that.printing = false;
                    that.$store.commit('setPrinting', false);
                    //this.$toast.success('打印成功');
                } catch (error) {
                    console.error('❌ iOS 前台打印失败:', error);
                    that.$store.commit('updateQtPrintCount', that.qtPrint_count + 1);
                    that.dcArray.splice(0, 1);
                    
                    // 重试逻辑 (最多3次)
                    if (that.qtPrint_count > 0 && that.qtPrint_count < 3) {
                        that.dcArray.push(that.currentPrint[0]);
                    } else {
                        that.$store.commit('updateQtPrintCount', 0);
                        this.$toast.fail('打印失败，请检查打印机连接');
                    }
                    that.printing = false;
                    that.$store.commit('setPrinting', false);
                }
            } else {
                // 蓝牙未连接
                that.$store.commit('updateQtPrintCount', 0);
                that.dcArray.splice(0, 1);
                that.printing = false;
                that.$store.commit('setPrinting', false);
                this.$toast.fail('蓝牙打印机未连接，请前往【打印机设置】连接');
            }
            return; // 🔑 提前返回，避免执行后续逻辑
        }
        // Windows版本和安卓版本都没有商米打印了
        if (localStorage.printType == 6) { // 大趋云打印机
          if (that.currentPrint[0].type == 15) { // 桌码
            let qrData = new FormData();
            qrData.append('print_content', that.currentPrint[0].qrcode);
            qrData.append('cloud_sn', localStorage.qtDeviceSN);
            this.$api.daqPrint_dqQr(qrData).then(res => {
              // console.log('前台 大趋云打印机二维码 res', res);
              if (res.code == 1) {
                that.dcArray.splice(0, 1);
                that.$store.commit('updateQtPrintCount', 0);
                that.printing = false;
                that.$store.commit('setPrinting', false);
              } else {
                that.dcArray.splice(0, 1);
                that.$store.commit('updateQtPrintCount', that.qtPrint_count + 1);
                that.printing = false;
                that.$store.commit('setPrinting', false);
                // console.log('前台 大趋云打印机二维码打印失败---', res);
                that.$toast(err.msg || '桌码打印失败')
              }
            }).catch((err) => {
              // console.log('前台 大趋云打印机二维码打印失败', err);
              that.printing = false;
              that.$store.commit('setPrinting', false);
              that.dcArray.splice(0, 1);
              that.$store.commit('updateQtPrintCount', that.qtPrint_count + 1);
              if (err) {
                that.$toast(err.msg || '桌码打印失败')
              }
            });
          } else if (that.currentPrint[0].type == 28 || that.currentPrint[0].type == 29) { // 寄存单、取回单
            let printdataOfOut = outPrintdataProcess(that.currentPrint[0], 'dqprint');
            // console.log('前台 处理后数据', JSON.stringify(printdataOfOut));
            let daD = new FormData();
            daD.append('print_content', JSON.stringify(printdataOfOut));
            daD.append('shop_id', localStorage.shop_id);
            daD.append('order_id', (that.currentPrint[0].oid || that.currentPrint[0].order_id) || 0);
            daD.append('cloud_sn', localStorage.qtDeviceSN);
            this.$api.daqPrint_printDeposit(daD).then(res => {
              // console.log('前台 大趋云打印机 res', res);
              if (res.code == 1) {
                that.dcArray.splice(0, 1);
                that.$store.commit('updateQtPrintCount', 0);
                that.printing = false;
                that.$store.commit('setPrinting', false);
              } else {
                that.dcArray.splice(0, 1);
                that.$store.commit('updateQtPrintCount', that.qtPrint_count + 1);
                that.printing = false;
                that.$store.commit('setPrinting', false);
                // console.log('前台 大趋云打印机打印失败---', res);
                that.$toast(res.msg || '前台打印失败')
              }
            }).catch((err) => {
              // console.log('前台 大趋云打印机打印失败', err);
              that.printing = false;
              that.$store.commit('setPrinting', false);
              that.dcArray.splice(0, 1);
              that.$store.commit('updateQtPrintCount', that.qtPrint_count + 1);
              if (err) {
                that.$toast(err.msg || '前台打印失败')
              }
            });
          } else {
            let printdataOfOut = outPrintdataProcess(that.currentPrint[0], 'dqprint');
            // console.log('前台 处理后数据', JSON.stringify(printdataOfOut));
            let daD = new FormData();
            daD.append('print_content', JSON.stringify(printdataOfOut));
            daD.append('shop_id', localStorage.shop_id);
            daD.append('order_id', (that.currentPrint[0].oid || that.currentPrint[0].order_id) || 0);
            daD.append('cloud_sn', localStorage.qtDeviceSN);
            this.$api.daqPrint_dqPrint(daD).then(res => {
              // console.log('前台 大趋云打印机 res', res);
              if (res.code == 1) {
                that.dcArray.splice(0, 1);
                that.$store.commit('updateQtPrintCount', 0);
                that.printing = false;
                that.$store.commit('setPrinting', false);
              } else {
                that.dcArray.splice(0, 1);
                that.$store.commit('updateQtPrintCount', that.qtPrint_count + 1);
                that.printing = false;
                that.$store.commit('setPrinting', false);
                // console.log('前台 大趋云打印机打印失败---', res);
                that.$toast(res.msg || '前台打印失败')
              }
            }).catch((err) => {
              // console.log('前台 大趋云打印机打印失败', err);
              that.printing = false;
              that.$store.commit('setPrinting', false);
              that.dcArray.splice(0, 1);
              that.$store.commit('updateQtPrintCount', that.qtPrint_count + 1);
              if (err) {
                that.$toast(err.msg || '前台打印失败')
              }
            });
          }
        }
        else if (localStorage.printType == 11) { // 佳博
          if (that.currentPrint[0].type == 28 || that.currentPrint[0].type == 29) {
            let printdataOfOut = outPrintdataProcess(that.currentPrint[0], 'dqprint');
            console.log('前台 处理后数据', printdataOfOut);
            let data = new FormData();
            data.append("print_content", JSON.stringify(printdataOfOut));
            data.append("cloud_sn", localStorage.qtDeviceSN);
            data.append("size", localStorage.qiantaiPrintSize || 58);
            this.$api.jiabo_printDeposit(data).then(res => {
              if (res.code == 1) {
                that.dcArray.splice(0, 1);
                that.$store.commit('updateQtPrintCount', 0);
                that.printing = false;
                that.$store.commit('setPrinting', false);
              } else {
                that.dcArray.splice(0, 1);
                that.$store.commit('updateQtPrintCount', that.qtPrint_count + 1);
                that.printing = false;
                that.$store.commit('setPrinting', false);
                // console.log('前台 佳博云打印机打印失败---', res);
                that.$toast(res.msg || '前台打印失败')
              }
            }).catch((err) => {
              // console.log('前台 佳博云打印机打印失败', err);
              that.printing = false;
              that.$store.commit('setPrinting', false);
              that.dcArray.splice(0, 1);
              that.$store.commit('updateQtPrintCount', that.qtPrint_count + 1);
              if (err) {
                that.$toast(err.msg || '前台打印失败')
              }
            });
          } else {
            let printdataOfOut = outPrintdataProcess(that.currentPrint[0], 'dqprint');
            // console.log('前台 处理后数据', JSON.stringify(printdataOfOut));
            let daD = new FormData();
            daD.append('print_content', JSON.stringify(printdataOfOut));
            daD.append('shop_id', localStorage.shop_id);
            daD.append('order_id', (that.currentPrint[0].oid || that.currentPrint[0].order_id) || 0);
            daD.append('cloud_sn', localStorage.qtDeviceSN);
            daD.append('size', localStorage.qiantaiPrintSize || 58);
            this.$api.jiabo_print(daD).then(res => {
              // console.log('前台 佳博云打印机 res', res);
              if (res.code == 1) {
                that.dcArray.splice(0, 1);
                that.$store.commit('updateQtPrintCount', 0);
                that.printing = false;
                that.$store.commit('setPrinting', false);
              } else {
                that.dcArray.splice(0, 1);
                that.$store.commit('updateQtPrintCount', that.qtPrint_count + 1);
                that.printing = false;
                that.$store.commit('setPrinting', false);
                // console.log('前台 佳博云打印机打印失败---', res);
                that.$toast(res.msg || '前台打印失败')
              }
            }).catch((err) => {
              // console.log('前台 佳博云打印机打印失败', err);
              that.printing = false;
              that.$store.commit('setPrinting', false);
              that.dcArray.splice(0, 1);
              that.$store.commit('updateQtPrintCount', that.qtPrint_count + 1);
              if (err) {
                that.$toast(err.msg || '前台打印失败')
              }
            });
          }
        }
        else {
          if (this.isApp == 'android' || (this.isApp == 'mt_android' && (localStorage.printType == 1 || localStorage.printType == 3))) {
            // 安卓
            if (localStorage.printType == 1) {
              checkUsbConnect();
            }
            if (that.currentPrint[0].type == 15) { // 桌码
              imagePrint(that.currentPrint[0].qrcode, localStorage.qiantaiPrintSize);
            } else {
              let printdataOfOut = outPrintdataProcess(that.currentPrint[0], '', localStorage.qiantaiPrintSize);
              console.log('处理后数据', JSON.stringify(printdataOfOut));
              beginPrint(printdataOfOut, localStorage.qiantaiPrintSize);
            }
            that.dcArray.splice(0, 1);
            that.$store.commit('updateQtPrintCount', 0);
            that.printing = false;
            that.$store.commit('setPrinting', false);
          } else if (this.isApp == 'windows') { // Windows
            if (localStorage.printType == 4 || localStorage.printType == 1) {
              //console.log('前台--------开始调起网络打印机打印');
              if (localStorage.printType == 4 && (!localStorage.qiantaiPrintIp || !localStorage.qiantaiPrintSize)) {
                this.$toast('前台打印机配置有误，请前往【设置】-【打印设置】中查看并重新配置')
                return
              }
              if (localStorage.printType == 1 && !localStorage.qiantaiPrintSize) {
                this.$toast('前台打印机配置有误，请前往【设置】-【打印设置】中查看并重新配置')
                return
              }
              // console.log(this.currentPrint[0].type);
              // this.printing = false;
              if (localStorage.printType == 4) {
                that.currentPrint[0].printChannel = 'network';
                that.currentPrint[0].ip = localStorage.qiantaiPrintIp;
                that.currentPrint[0].size = localStorage.qiantaiPrintSize;
                // 如果存在ips就取当前数据中的ip和size，否则就取本机默认的
                // if (!that.currentPrint[0].ips) {
                //   that.currentPrint[0].ip = localStorage.qiantaiPrintIp;
                //   that.currentPrint[0].size = localStorage.qiantaiPrintSize;
                // }
              } else if (localStorage.printType == 1) {
                that.currentPrint[0].printChannel = 'usb';
                that.currentPrint[0].size = localStorage.qiantaiPrintSize;
              }
              console.log('前台打印开始', that.currentPrint[0]);
              netPrintSend(that.currentPrint[0]).then(res => {
                // console.log('前台 网络打印机打印 res', res);
                if (res.code == 1) {
                  that.printing = false;
                  that.$store.commit('setPrinting', false);
                  that.$store.commit('updateQtPrintCount', 0);
                  that.dcArray.splice(0, 1);
                  // console.log('前台 网络打印机打印成功1-1', cutArray)
                } else {
                  that.dcArray.splice(0, 1);
                  that.$store.commit('updateQtPrintCount', that.qtPrint_count + 1);
                  that.printing = false;
                  that.$store.commit('setPrinting', false);
                  // console.log('前台 网络打印机打印失败---', res);
                  that.$toast('前台打印失败')
                }
              }).catch((err) => {
                // console.log('前台 网络打印机打印失败', err);
                that.printing = false;
                that.$store.commit('setPrinting', false);
                that.dcArray.splice(0, 1);
                that.$store.commit('updateQtPrintCount', that.qtPrint_count + 1);
                if (err) {
                  that.$toast(err.msg || '前台打印失败')
                }
              });
            } else if (localStorage.printType == 5) {
              // if (!localStorage.qt_printer_name || !localStorage.qiantaiPrintSize) {
              //   this.$toast('前台打印机配置有误，请前往【设置】-【打印设置】中查看并重新配置');
              //   return
              // }
              winPrintSend(that.currentPrint[0]).then(res => {
                that.printing = false;
                that.$store.commit('setPrinting', false);
                that.$store.commit('updateQtPrintCount', 0);
                that.dcArray.splice(0, 1);
                // console.log('前台 网络打印机打印成功1-1', cutArray)
              }).catch((err) => {
                that.dcArray.splice(0, 1);
                that.$store.commit('updateQtPrintCount', that.qtPrint_count + 1);
                that.printing = false;
                that.$store.commit('setPrinting', false);
                if (err) {
                  that.$toast(err.msg || '打印失败')
                }
                // console.log('前台 网络打印机打印失败', err);
              });
            }
          } else if (this.isApp == 'mt_android' && localStorage.printType == 10) { // 美团收银机
            getPrinterStatus();
            if (that.currentPrint[0].type == 15) { // 桌码
              return;
            }
            let printdataOfOut = outPrintdataProcess(that.currentPrint[0], '', localStorage.qiantaiPrintSize);
            // console.log('处理后数据', printdataOfOut);
            const mtRes = await mtPrintText(printdataOfOut, localStorage.qiantaiPrintSize);
            that.dcArray.splice(0, 1);
            that.$store.commit('updateQtPrintCount', 0);
            that.printing = false;
            that.$store.commit('setPrinting', false);
            if (mtRes.code == 2) {
              this.$toast(mtRes.msg || '内置打印机打印失败');
            }
          }
        }
      }
    },
    // 🆕 新增：iOS 蓝牙前台小票打印方法
    iosReceiptPrint(printData, size) {
        return new Promise((resolve, reject) => {
            if (!window.cordova || !window.cordova.plugins || !window.DzbIosPrint) {
                reject('iOS 打印插件未加载');
                return;
            }
            console.log('🖨️ 调用 iOS 前台小票打印:', printData, size);            
            // 方式1: 如果插件有专门的前台小票打印方法
            if (DzbIosPrint.receiptPrintText) {
                DzbIosPrint.receiptPrintText(printData, size).then(function(info) {
                    console.log('✅ iOS 前台小票打印成功:', info);
                    resolve(info);
                }).catch(function(error){
                    console.error('❌ iOS 前台小票打印失败:', error);
                    reject(error);
                });
            }
        });
    },
    uuid2(len, radix) {
      var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
      var uuid = [],
        i;
      radix = radix || chars.length;

      if (len) {
        // Compact form
        for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
      } else {
        // rfc4122, version 4 form
        var r;

        // rfc4122 requires these characters
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
        uuid[14] = '4';

        // Fill in random data.  At i==19 set the high bits of clock sequence as
        // per rfc4122, sec. 4.1.5
        for (i = 0; i < 36; i++) {
          if (!uuid[i]) {
            r = 0 | Math.random() * 16;
            uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
          }
        }
      }

      return uuid.join('');
    },
  },
};
</script>
<style lang="less">
.red {
  color: red;
}

.yellow {
  color: rgb(255, 190, 0);
}

.green {
  color: rgb(114, 191, 0);
}

.latency {
  position: absolute;
  top: 0.1rem;
  right: 0.1rem;
  font-size: 0.16rem;
  z-index: 9999;
}

.logger tr {
  text-align: left;
}

.success {
  color: green;
}

.fail {
  color: red;
}

.mainContainer {
  z-index: 0;
}

.closeLOG {
  position: fixed;
  top: 1.2rem;
  right: 2rem;
  font-size: 0.3rem;
  background: red;
  color: #fff;
  padding: 0.2rem;
  border-radius: 0.2rem;
  z-index: 20000;
}

.closeLOG2 {
  position: fixed;
  top: 1.2rem;
  right: 3.2rem;
  font-size: 0.3rem;
  background: red;
  color: #fff;
  padding: 0.2rem;
  border-radius: 0.2rem;
  z-index: 20000;
}

.logger {
  position: fixed;
  overflow-y: scroll;
  line-height: 1.15;
  top: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  background: black;
  color: #fff;
  font-size: 0.4rem;
  padding: 0.2rem 0.3rem;
  z-index: 19999;
}

.logger form {
  text-align: left;
}

.onTop {
  position: fixed;
  top: 1.2rem;
  right: 10px;
  font-size: 0.3rem;
  background: red;
  color: #fff;
  padding: 0.2rem;
  border-radius: 0.2rem;
  z-index: 20000;
}

.onTop2 {
  position: fixed;
  top: 0.2rem;
  right: 10px;
  font-size: 0.3rem;
  background: red;
  color: #fff;
  padding: 0.2rem;
  border-radius: 0.2rem;
  z-index: 20000;
}

.printTest {
  position: fixed;
  top: 10%;
  right: 0;
  width: 2rem;
  height: 2rem;
  z-index: 9999;
  background: blue;
}

.mainContainer {
  height: 100vh;
  overflow: hidden;
  background: #f4f4f4;

  .popup-picker-custom {
    width: 42%;
    left: 29%;
  }
}

#app {
  line-height: 1;
}

.deviceHeader {
  display: block;
  width: 1366px;
  height: 40px;
}

.devicefooter {
  position: fixed;
  bottom: 0;
  height: 48px;
  right: 0;
  z-index: 6666;
}

.printerPopOut {
  position: fixed;
  right: 1rem;
  top: 1rem;
  width: 1rem;
  height: 1rem;
  color: black;
}

.van-dialog__content .van-dialog__message,
.van-dialog__footer .van-button {
  font-size: 16px;
}

/* ::-webkit-scrollbar {
  width: 0.04rem;
  height: 0.05rem;
  background-color: #fff;
}

::-webkit-scrollbar-thumb {
  display: block;
  min-height: 0.05rem;
  min-width: 0.04rem;
  border-radius: 0.1rem;
  background-color: rgb(217, 217, 217);
}

::-webkit-scrollbar-thumb:hover {
  display: block;
  min-height: 0.05rem;
  min-width: 0.04rem;
  border-radius: 0.1rem;
  background-color: rgb(159, 159, 159);
} */
</style>



// WEBPACK FOOTER //
// src/App.vue